import * as AppSettingsSystem from "config/variables.system";
import * as AppSettingsBuilder from "config/variables.builder";
import * as AppSettingSubcontractor from "config/variables.subcontractor";
import * as AppSettingsHomeowner from "config/variables.homeowner";

let AppSettings;
console.log("appsetting", window.profile.clientTypeValue);
if (window.profile.clientTypeValue === "Builder") {
  AppSettings = { ...AppSettingsBuilder };
} else if (window.profile.clientTypeValue === "Subcontractor") {
  AppSettings = { ...AppSettingSubcontractor };
} else if (window.profile.clientTypeValue === "Homeowner") {
  AppSettings = { ...AppSettingsHomeowner };
} else {
  AppSettings = { ...AppSettingsSystem };
}
AppSettings["clientTypeValue"] = window.profile.clientTypeValue;
AppSettings["customTerms"] = window.profile.customTerms;
AppSettings["clientId"] = window.profile.clientId;
console.log("::AppSettings::", AppSettings);
export { AppSettings };



// WEBPACK FOOTER //
// ./src/constants.js